var _path, _path2, _path3, _path4, _path5;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTtdInfoFlashIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 29,
    viewBox: "0 0 28 29",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.2965 15.9719H15.82V21.8519C15.82 22.7176 16.898 23.1259 17.4697 22.4726L23.6518 15.4492C24.1908 14.8367 23.758 13.8812 22.9413 13.8812H20.4178V8.00123C20.4178 7.13556 19.3398 6.72723 18.7682 7.38056L12.586 14.4039C12.0552 15.0164 12.488 15.9719 13.2965 15.9719Z",
    fill: "#D1D9FF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.4967 14.5735H13.0202V20.4535C13.0202 21.3191 14.0982 21.7275 14.6699 21.0741L20.852 14.0508C21.391 13.4383 20.9582 12.4828 20.1415 12.4828H17.618V6.60279C17.618 5.73712 16.54 5.32879 15.9683 5.98212L9.7862 13.0055C9.25537 13.618 9.6882 14.5735 10.4967 14.5735Z",
    fill: "white",
    stroke: "#4258BF",
    strokeWidth: 1.4,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M9.82702 6.99219H4.11035",
    stroke: "#D1D9FF",
    strokeWidth: 1.4,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M9.01035 20.0586H4.11035",
    stroke: "#D1D9FF",
    strokeWidth: 1.4,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M6.56035 13.5273H4.11035",
    stroke: "#D1D9FF",
    strokeWidth: 1.4,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTtdInfoFlashIcon);
export default __webpack_public_path__ + "static/media/ttd-info-flash-icon.b93fca24e1819266edf041088930d1c2.svg";
export { ForwardRef as ReactComponent };